import { Accordion } from 'react-bootstrap';

const InformacionAdicionalFotoMulta = (props) => {
  const { informacionAdicional } = props;
  return (
    <div>
      <Accordion>
        <Accordion.Item eventKey="0">
          <Accordion.Header>Información Adicional</Accordion.Header>
          <Accordion.Body>
            {Object.entries(informacionAdicional)?.map((key) => {
              return (
                <p className="mb-0" key={key[0]}>
                  <span className="fw-semibold text-secondary text-uppercase">{key[0]?.replaceAll('_', ' ')}: </span>{' '}
                  {key[1]}
                </p>
              );
            })}
          </Accordion.Body>
        </Accordion.Item>
      </Accordion>
    </div>
  );
};

export default InformacionAdicionalFotoMulta;
